<div class="row g-0">
    <div class="col-11">
        <span class="pre-line">{{snackBarRef.instance.data.Text}}</span>
    </div>
    <mat-icon class="clickable col-1 m-auto text-end material-symbols-outlined" (click)="dismiss()">cancel</mat-icon>
    <div class="col-12">
        @if (snackBarRef.instance.data.Severity === 0) {
        <div class="bottom-line severity-0-color"></div>
        }
        @if (snackBarRef.instance.data.Severity === 1) {
        <div class="bottom-line severity-1-color"></div>
        }
        @if (snackBarRef.instance.data.Severity === 2) {
        <div class="bottom-line severity-2-color"></div>
        }
        @if (snackBarRef.instance.data.Severity === 3) {
        <div class="bottom-line severity-3-color"></div>
        }
    </div>
</div>